<template>
 <div> {{ActDescBtn}}
 <table style="position: absolute;" width="100%"  :height="this.windowSize.height-8"  :max-height="this.windowSize.height-8" >
   <tr max-height="48px" height="48px">   

<ContenidoBase 
  :titulo="'Devolución a Clientes'"
  :descripcion="'Devolución a Clientes.'"
   :EstadoBtn="EstadoBtn"
   @abrirBarraTablaDinamica="abrirTabla"
   @MethodNuevo="newwnuevo"
   @MethodGuardar="FinalizarDevolucionFactura"
   @MethodEliminar="remove"
   @MethodAnular="anular"
   @MethodImprimir="imprimirList"  
/>
    </tr>
    <tr>
<!-- BarraPrimaria --------------------------------------------------------------------------------->
      <td width="109" :max-height="this.windowSize.height-96" v-show="BarraTablaDinamicaAprir">

         <div class="overflow-y-auto " v-bind:style="{  'max-height':this.windowSize.height-96+ 'px' , 'max-width': '325px', 'width': '325px'  }">
        
        <v-tooltip left>
          <template v-slot:activator="{ on }">
              <center>
             <v-btn-toggle>
                    <v-btn color="teal darken-2" dark text small
                      @click.prevent="dialogFiltros = true, ObjTemTbDinam = JSON.parse(JSON.stringify(Modallfiltro))">
                      <i style="font-size: 25px;" class="fa fa-search"> </i>
                      Filtrar
                    </v-btn>
                  </v-btn-toggle>
            </center>
                            <BarraDinamicaLimitePlus :PropsNombre="'Devolución'" PropsSearchNumber
                  :PropsSeachNombre="'Búsqueda por código'" :TbPaginator="TbPaginatorBarraDin" :TbTotalItem="TbTotalItemBarraDin"
                  :PropsList="ListItemsBarraDin" @CargarPaginacion="CargarPaginacionBarraDin" @EmitDAta="datostabla" :headers="[
                    { text: 'Código', value: 'devoclucionPK.secuencia' },
                    // { text: 'cliente', value: 'cliente.nombre' },
                    { text: 'valor', value: 'valor' },
                    { text: 'concepto', value: 'concepto' },
                    { text: 'referencia', value: 'referencia' },
                    { text: 'ncf', value: 'ncf' },
                    /* { text: 'Nombre', value: 'nombre' },
                     { text: 'Balance', value: 'balancecliente.balance' }*/
                  ]" :ContListSlot="[
  { Text: 'Código', NomValue: 'devoclucionPK', Nv2: 'secuencia', Ctsl: 2, Type: 0, State: true },
  { Text: 'Nombre', NomValue: 'facturasventa', Nv2: 'cliente',  Nv3: 'nombre'  , Ctsl: 3, Type: 0, State: true },
  { Text: 'Valor $', NomValue: 'valor', Ctsl: 1, Type: 2, State: true },
  { Text: 'referencia', NomValue: 'referencia', Ctsl: 1, Type: 0, State: true },
  { Text: 'concepto', NomValue: 'concepto', Ctsl: 1, Type: 0, State: true },
  { Text: 'ncf', NomValue: 'ncf', Ctsl: 1, Type: 0, State: true },
  { Text: 'Estado', NomValue: 'activo', Ctsl: 1, Type: 0.2, State: true }
]" />
          </template>
        </v-tooltip>




      </div>
      </td>
<!-- fn BarraPrimaria ---------------------------------------------------------------------------------->
<!-- contenido central -------------------------------------------------------------------------------->
      <td :max-height="this.windowSize.height-96" >
        <v-app id="inspire" class="overflow-y-auto " v-bind:style="{  'max-height':this.windowSize.height-96+ 'px' }">
 

 <div class="px-2" >
  <v-card color="grey lighten-3">
  <div class="px-2" style="border: 1px solid #000000" >
  <!-- <v-form ref="formFactVenta" @submit.prevent=""  v-model="valid" lazy-validation translate="no" class="notranslate"> -->
<!-- fn columna header --> 
<v-col  cols="12" md="12" sm="12" class="pa-0 ma-0 py-0 my-0 pt-2" > 
 <v-row class="pa-0 ma-0 py-0 my-0">
 <!-- COL 1 COLUMNA 1 -->
 <v-col cols="12" md="6" sm="6" class="pa-0 ma-0 px-2">
<v-form ref="formFactVenta" @submit.prevent=""  v-model="valid" lazy-validation translate="no" class="notranslate"> 
 <v-combobox v-model="devClientes.documentoNotaCredito" class="fontSize13" id="formdisabledInput" label="Documento :"  :rules="[$rules.required]"
                      outlined dense autocomplete="off" :items="RDocumentoNotacredito" item-text="descripcion" hide-details @blur="SelectCbDocNotacredito" 
                      @focus="CargarRDocumentoNotacredito" @change="changeCbNotaCredito"
                       :disabled="devClientes.soloImprimir==true" >
                      <template v-slot:prepend>
                       <i class="fa fa-book" style="font-size: 18px;"></i>
                      </template>
</v-combobox>

 <!-- COL 1 ROW 1 -->
<v-row class="pa-0 ma-0 py-0 my-0">

<v-col cols="12" md="6" sm="6" class="px-0" >
<v-text-field label="Secuencia:"v-model.number="devClientes.secuencia" disabled  class="fontSize13" id="formdisabledInput"
autocomplete="off" dense hide-details outlined placeholder=" "
                                          @keyup="KeyUpCantidad">
                            <template v-slot:prepend>
                              <i class="fa fa-slack" style="font-size: 18px;"></i>
                            </template>
</v-text-field>
</v-col>

<v-col cols="12" md="6" sm="6" class="px-0"  >
<v-text-field label="Doc.:" dense outlined v-model="devClientes.referencia" hide-details
class="fontSize13" id="formdisabledInput" :disabled="devClientes.soloImprimir==true"
                          autocomplete="off"  
                          >
                          <template v-slot:prepend>
                            <i style="font-size: 20px;" class="fa fa-map-signs"></i>
                          </template>
</v-text-field>
</v-col>

<v-col cols="12" md="6" sm="6" class="px-0 pt-0" >
<v-text-field v-model="devClientes.fecha" :rules="[$rules.required]" dense hide-details
class="fontSize13" id="formdisabledInput" label="FECHA " disabled outlined  type="date">
   <template v-slot:prepend>
    <i class="fa fa-calendar" style="font-size: 20px;"></i>
  </template>
</v-text-field>
</v-col>

<v-col cols="12" md="6" sm="6" class="px-0 pt-0" >
<v-text-field v-model="devClientes.ncf" autocomplete="off" dense hide-details label="NCF"
 outlined style="font-size: 12px;" disabled  class="fontSize13" id="formdisabledInput" >
                            <template v-slot:prepend>
                              <i class="fa fa-barcode" style="font-size: 20px;"></i>
                            </template>
</v-text-field>
</v-col>

<v-col cols="12" md="12" sm="12" class="px-0 pt-0" >
<v-combobox
            autocomplete="off"
            dense
            outlined
            label="Cliente:"
            :items="RCliente"
            item-text="codnom"
            :suffix="infCliente.telefono"
           class="fontSize13" id="formdisabledInput"
            v-model="devClientes.cliente"
            @focus="cargarCliente"
            @keyup="CbFilcliente"
            @blur="SelctCbCliente"
            @change="changeCbCliente"
            no-filter
            hide-details
            :rules="[$rules.required]"
            :disabled="devClientes.soloImprimir==true"
          >
          <template slot="item" slot-scope="item">
                  <span style="display:none;">{{ item.item.codnom = `${item.item.codigo} - ${item.item.nombre.trim()} ` }}</span>
                  <span class="fontSize13"><b>{{ item.item.codigo}}</b> - {{item.item.nombre.trim()}}</span>
                  </template>

                  <template v-slot:selection="{ attrs, item, parent, selected }">
                    <span class="fontSize13 colorNombre" v-if="item.hasOwnProperty('codigo')" ><b>{{ item.codigo}}</b> - {{item.nombre}}</span>
                    <span class="fontSize13 colorNombre" v-if="item!=null && !item.hasOwnProperty('codigo')" >{{item}}</span>
                  </template>

                      <template v-slot:prepend>
                        <i style="font-size: 20px;" class="fa fa-user-circle"></i>
                      </template>
</v-combobox>
</v-col>

<v-col cols="12" md="12" sm="12" class="px-0 pt-0" >
   <v-combobox
                            autocomplete="off"
                            dense
                            outlined
                            label="Vendedores:"
                            :items="RVendedores"
                            item-text="nombre"
                            hide-details
                            v-model="devClientes.vendedor"
                            @blur="SelctCbVendedores"
                            @focus="cargarVendedores"
                            class="fontSize13" id="formdisabledInput"
                            disabled
                        >
                          <template v-slot:prepend>
                            <i style="font-size: 20px;" class="fa fa-sign-language"></i>
                          </template>
  </v-combobox>
</v-col>

</v-row>
 <!-- FIN COL 1 ROW 1 -->
</v-form>
 </v-col>
 <!-- FN COL 1 COLUMNA 1 -->

<!-- COL 2 FACTURAS PENDIENTE   -->
<v-col cols="12" md="6" sm="6" class="pa-0 ma-0 px-2">
     <v-card>
              <v-col style="background-color:#BDBDBD; border: 1px solid #000000; " class="pa-0 ma-0 py-0 my-0" cols="12" md="12" sm="12">
                <span :class="`d-flex justify-center black--text`"><b>FACTURAS</b></span>
              </v-col>
<div style="border: 1px solid #000000; max-height:223px; height:223px;" class="overflow-x-auto" >
<v-data-table
                        class="RowSelectColor TbSize10"
                        :single-select="true"
                        item-key="indx"
                        :show-select="true"
                        v-model="selectedlistFactVent"
                        @item-selected="DevolucionObtenerDatoSelect"
                        :footer-props="arrayPropiedases"
                        :headers="[
                          { text: 'FECHA', sortable: false, value: 'fecha', width: 98, class: ['no-gutters black--text'] },
                          { text: 'FACTURA', sortable: false, value: 'secu', width: 110, class: ['no-gutters black--text'] },
                          { text: 'VALOR', sortable: false, value: 'valor', width: 'auto', width: 105, class: ['no-gutters black--text'] },
                          { text: 'PENDIENTE', sortable: false, value: 'valor', width: 'auto', width: 105, class: ['no-gutters black--text'] },
                        ]"
                        dense
                        :items="listFactVent"
                        @click:row="DevolucionDatostabla"
                        @pagination="cargarPaginacion"
                        :items-per-page="TbPaginator.itemsPerPage"
                        :server-items-length="TotalRegistros"
                      >
                        <template v-slot:item.action="{ item }">
                          <!-- <v-btn fab @click.prevent="VerReporte(item)" x-small color="yellow accent-4"><i style="font-size: 20px;" class="fa fa-eye"></i></v-btn>  -->
                          <v-btn fab @click.prevent="deleFact(item)" x-small color="red darken-3">
                            <i style="font-size: 20px" class="fa fa-trash-o"></i>
                          </v-btn>
                        </template>

                        <template v-slot:item.fecha="props">
                          <span style="font-size: 12px; display: none">
                            {{ (props.item.indx = listFactVent.indexOf(props.item)) }}
                          </span>
                          <span >{{ FormatoFecha(props.item.fecha) }}</span>
                        </template>
                        <template v-slot:item.secu="props">
                          <span >{{ props.item.documentoFactura.nombrecorto.trim() }}-{{props.item.facturasventaPK.secuencia }} </span>
                          <!-- <span style="font-size: 13px">{{ props.item.facturasventaPK.secuencia }}</span> -->
                        </template>
                        <template v-slot:item.ncf="props">
                          <span>{{ props.item.ncf }}</span>
                        </template>

                        <template v-slot:item.clinica.nombre="props">
                          <span v-if="props.item.cliente != null" >{{ props.item.cliente.nombre }}</span>
                        </template>

                        <template v-slot:item.sucursal.descripcion="props">
                          <span v-if="props.item.sucursal != null" >{{ props.item.sucursal.descripcion }}</span>
                        </template>

                        <template v-slot:item.valor="props">
                          <span>{{ currencyFormatter(props.item.valor) }}</span>
                        </template>

                      </v-data-table>
</div>
              
    </v-card>         
</v-col>
 <!-- FN COL 2 FACTURAS PENDIENTE  -->


</v-row>
</v-col>
<!-- fn columna header  -->    
<!-- </v-form> -->
</div>
  </v-card>
  <!-- -------------------------------------------------------------------------- -->
<v-card color="grey lighten-3" >
  <div class="px-1 pb-2" style="border: 1px solid #000000"  >
<!-- columna Detalle  -->   
<v-col cols="12" md="12" sm="12" class="pa-0 ma-0 py-0 my-0 pt-2" >
 
  <v-row class="pa-0 ma-0 py-0 my-0">

    <!-- COL FACTURAS PENDIENTE 1 -->
    <v-col cols="12" md="4" sm="4" class="pa-0 ma-0 py-0 my-0 pt-2" >
    
    </v-col>
     <!-- FN COL FACTURAS PENDIENTE -->

       <!-- COL 2 COLUMNA 2 -->
    <v-col cols="12" md="12" sm="12" class="pa-0 ma-0 py-0 my-0 pt-2" >
    <v-card >
    <v-col style="background-color:#BDBDBD; border: 1px solid #000000; " class="pa-0 ma-0 py-0 my-0" cols="12" md="12" sm="12">
    <span :class="`d-flex justify-center black--text`"><b>PRODUCTOS</b></span>
    </v-col>

      <div style="border: 1px solid #000000;">
        <!-- <p style="border: 1px dashed  #616161;"> </p> -->
                    <strong style="color:#000000; font-size:13px;">El valor de la devolucion sera RD$:
                      {{ DevolucionFacturaSeleccionada.valordevolucion }}</strong>
                    <v-data-table item-key="indx" id="TbBord" class="RowSelectColor TbSize11"
                    :loading="loaderTabla"
                       :headers="[
                       { text: 'COD PROD.', value: 'codprod', sortable: false, width: 150, class: ['no-gutters black--text'] },
                       { text: 'DESCRIPCIÓN', value: 'descripcion', sortable: false, width: 'auto', class: ['no-gutters black--text'] },
                        { text: 'CANTIDAD', value: 'cantidad', sortable: false, width: 120, class: ['no-gutters black--text'] },
                        { text: 'PRECIO', value: 'precio', sortable: false, width: 150, class: ['no-gutters black--text'] },
                        { text: '(QUITAR) ITBIS', value: 'valorimpuesto', sortable: false, width: 150, class: ['no-gutters black--text'] },
                        { text: 'VALOR', value: 'valor', sortable: false, width: 150, class: ['no-gutters black--text'] },
                      ]" dense :items="DevolucionFacturaSeleccionada.SeletDetalleList" :items-per-page="15">
                      <template v-slot:item.descripcion="props">
                        <span style="font-size:13px; display:none;">{{ props.item.indx =DevolucionFacturaSeleccionada.SeletDetalleList.indexOf(props.item)}}</span>
                        <!-- <span >{{ props.item.descripcion }}</span> -->
                        <v-text-field label="" dense outlined :value="props.item.descripcion" hide-details
                        class="fontSize11" id="formdisabledInput" autocomplete="off" disabled >
                        </v-text-field>
                      </template>

                      <template v-slot:item.codprod="props">
                        <v-text-field label="" dense outlined v-model="props.item.codprod" hide-details
                        class="fontSize11" id="formdisabledInput" autocomplete="off"
                        @keyup.enter="SeachFilkeyEnterProd(props.item)"
                        :disabled="devClientes.soloImprimir==true" >
                        </v-text-field>
                      </template>

                      <template v-slot:item.cantidad="props">
                        <!-- <span style="font-size:13px; display:none;">{{props.item.cantidad = props.item.cantidadPendiente}}</span> -->
                        <VueAutonumeric label="" class="fontSize11" dense hide-details outlined autocomplete="off"
                          v-model.number="props.item.cantidad" v-on:blur="DevolucionValorTotal()"
                          @blur="DevolucionVerificaCantidad(props.item)"
                          id="formdisabledInput" :disabled="devClientes.soloImprimir==true">
                        </VueAutonumeric>
                      </template>

                      <template v-slot:item.precio="props"><!-- {{ currencyFormatter(props.item.precio) }} -->
                      <!-- <span>{{ currencyFormatter2TasaInf(getTasaInfo(props.item.precio,DevolucionFacturaSeleccionada.tasa),DevolucionFacturaSeleccionada.tasa)}}</span> -->
                         <v-text-field label="" dense outlined :value="currencyFormatter2TasaInf(getTasaInfo(props.item.precio,DevolucionFacturaSeleccionada.tasa),DevolucionFacturaSeleccionada.tasa)" hide-details
                        class="fontSize11" id="formdisabledInput" disabled autocomplete="off" >
                        </v-text-field>
                      </template>

                      <template v-slot:item.valorimpuesto="props"><!-- {{ currencyFormatter(props.item.precio) }} -->
                        <!-- <span>{{ currencyFormatter2TasaInf(getTasaInfo(props.item.valorimpuesto,DevolucionFacturaSeleccionada.tasa),DevolucionFacturaSeleccionada.tasa)  }}</span> -->
                        
                        <v-row no-gutters>
<!-- class="px-4" -->
                          <v-col class="pa-0 ma-0 py-0 my-0" cols="2" md="2" sm="2" style="border: 1px solid #000000;">
                                  <v-checkbox
                                  @change="changeItbisProd(props.item)"
                                  color="teal"
                                  class="mt-0"
                                  label=""
                                  v-model="props.item.quitaritbis"
                                  hide-details>
                                </v-checkbox>
                          </v-col>
                         <v-col class="pa-0 ma-0 py-0 my-0" cols="10" md="10" sm="10" >
                          <v-text-field label="" dense outlined :value="currencyFormatter2TasaInf(getTasaInfo(props.item.valorimpuesto,DevolucionFacturaSeleccionada.tasa),DevolucionFacturaSeleccionada.tasa)" hide-details
                           class="fontSize11" id="formdisabledInput" disabled autocomplete="off" >
                        </v-text-field>
                         </v-col>

                         </v-row>
                       
                        
                      </template>

                      <template v-slot:item.valor="props"><!-- {{ currencyFormatter(DevolucionValor(props.item)) }} -->
                        <!-- <span>{{ currencyFormatter2TasaInf(getTasaInfo(DevolucionValor(props.item),DevolucionFacturaSeleccionada.tasa),DevolucionFacturaSeleccionada.tasa)  }}</span> -->
                        <v-text-field label="" dense outlined :value="currencyFormatter2TasaInf(getTasaInfo(DevolucionValor(props.item),DevolucionFacturaSeleccionada.tasa),DevolucionFacturaSeleccionada.tasa)" hide-details
                        class="fontSize11" id="formdisabledInput" disabled  autocomplete="off" >
                        </v-text-field>
                      </template>

                    </v-data-table>
                    <!-- Tabla ReimprecionFacturaSeleccionada de factura   -->
       

      </div>
              

    </v-card>
     
    </v-col>
     <!-- FN COL 2 COLUMNA 2 -->


  </v-row>

</v-col>
<!-- fn columna Detalle -->
</div>
</v-card>

  

 </div>

        </v-app> 
      </td>
<!-- fn contenido central ------------------------------------------------------------------------------------->
<!-- BarraSecundaria ------------------------------------------------------------------------------------------>
      <td width="109" :max-height="this.windowSize.height-96" v-show="BarraSecundariaAprir" >

 <div  class="overflow-y-auto " v-bind:style="{  'max-height':this.windowSize.height-96+ 'px' , 'max-width': '325px', 'width': '325px' }">
        
<!--         
        <BarraBusqueda2
              :url="$hostname + $hName + '/services/caja/findAll'"
              :nombre="'Cajas'"
              :headers="headers"
              :slotname="'item.descripcion'"
              :emitnombre="'emitCaja'"
              :slotlist="slotlist"
              :SeachNombre="'Búsqueda por descripción caja'"
            /> -->
</div>

      </td>
<!-- fn BarraSecundaria --------------------------------------------------------------------------------------->



    </tr>
  </table>
<!-- Modales -------------------------------------------------------------------------------------------------->
  <!-- ------------------------------------------------------ tb-data-->
    <v-dialog
      label="myAlert"
      v-model="acti_tb_data"
      persistent
      max-width="100%"
      max-height="100%"
      transition="fab-transition"
    >
      <v-card>
        <v-toolbar flat color="#BDBDBD">
          <i style="font-size: 20px;" class="fa fa-file-pdf-o"></i>
          <v-toolbar-title class="font-weight-light"> REPORTE </v-toolbar-title>
          <i style="font-size: 20px;" class="fa fa-file-pdf-o"> </i>

          <v-spacer></v-spacer>
          <v-btn
            color="grey darken-4"
            fab
            small
            @click="acti_tb_data = !acti_tb_data"
          >
            <i style="font-size: 20px; color:#dd4b39;" class="fa fa-close"></i>
          </v-btn>
        </v-toolbar>

        <v-card-text>
          <v-card>
            <v-card-title>
              <v-text-field
                v-model="search"
                @keyup="filtro"
                label="Buscar"
                single-line
                hide-details
              >
                <template v-slot:prepend-inner>
                  <i style="font-size: 35px;" class="fa fa-search"></i>
                </template>
              </v-text-field>
            </v-card-title>

            <v-data-table
              :headers="slotHtabla"
              dense
              :items="list"
              :search="search"
              @click:row="datostabla"
            >
              <template v-slot:item.porciento="props">
                <span>{{ currencyFormatter(props.item.porciento) }}</span>
              </template>
            </v-data-table>
          </v-card>
        </v-card-text>
      </v-card>
    </v-dialog>
    <!-- ------------------------------------------------------ Elim_notif-->
    <v-dialog
      label="myAlert"
      v-model="Elim_notif.estado"
      persistent
      max-width="350"
      transition="fab-transition"
    >
      <template justify="center" v-slot:activator="{ on }"></template>

      <v-card>
        <v-card-title>
          <h4>
            <i style="font-size: 28px;" class="fa fa-warning"></i>
            CONFIRMACION
            <i style="font-size: 28px;" class="fa fa-warning"></i>
          </h4>
        </v-card-title>
        <hr />

        <v-card-text>
          <h5>{{ Elim_notif.nombre }}</h5>
        </v-card-text>

        <hr />
        <v-card-actions>
          <v-btn
            @click.prevent="
              eliminar(), (Elim_notif.estado = !Elim_notif.estado)
            "
            small
          >
            <i style="font-size: 20px;" class="fa fa-check"></i> Si
          </v-btn>

          <v-btn @click.prevent="Elim_notif.estado = !Elim_notif.estado" small>
            <i style="font-size: 20px;" class="fa fa-ban"></i> No
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- ------------------------------------------------------  fn Elim_notif -->

    <!------------otras funciones---------------->
    <v-snackbar
      v-model="aalert.estado"
      :color="aalert.color"
      style="margin-top: 20%;"
      :vertical="true"
      :timeout="120000"
      top="top"
    >
      {{ aalert.nombre }}
      <v-btn dark text @click="aalert.estado = false">Close</v-btn>
    </v-snackbar>

<!-- ------------------------------------------------------ Modal-Filtro tb-datos  -->
<v-dialog transition="fab-transition" label="Modal agregar factura" v-model="dialogFiltros" persistent max-width="90%"
  max-height="80%">
  <v-card>

    <v-toolbar flat color="indigo" dense>

      <i style="font-size: 20px;" class=""> </i>
      <v-toolbar-title style="color:white;" class="font-weight-light"> <b>FILTROS</b></v-toolbar-title>
      <i style="font-size: 20px;" class=""> </i>

      <v-spacer></v-spacer>
      <v-btn color="grey darken-4" fab small
        @click="dialogFiltros = false, Modallfiltro = JSON.parse(JSON.stringify(ObjTemTbDinam))">
        <i style="font-size: 20px; color:white;" class="fa fa-close"></i>
      </v-btn>
    </v-toolbar>

    <v-card-text>
      <br>

      <v-row>


        <v-col cols="12" md="12">
          <!-------------------------------------------------- Nombre  -->

          <v-combobox autocomplete="off" dense outlined label="Nombre:" :items="RCliente" item-text="codnom"
            :rules="[$rules.required]" v-model="Modallfiltro.cliente" @blur="SelctCbClienteFiltro"
            @focus="cargarCliente" @keyup="CbFilcliente" no-filter>
            <template slot="item" slot-scope="item">
                  <span style="display:none;">{{ item.item.codnom = `${item.item.codigo} - ${item.item.nombre.trim()} ` }}</span>
                  <span class="fontSize13"><b>{{ item.item.codigo}}</b> - {{item.item.nombre.trim()}}</span>
                  </template>

                  <template v-slot:selection="{ attrs, item, parent, selected }">
                    <span class="fontSize13 colorNombre"><b>{{ item.codigo}}</b> - {{item.nombre.trim()}}</span>
                  </template>
            <template v-slot:prepend>
              <i style="font-size: 20px;" class="fa fa-user-circle"></i>
            </template>
          </v-combobox>


          <!---------------------------------------------- documento -->
          <v-combobox v-if="false" autocomplete="off" dense outlined label="Documentos:" :items="RDocumentoNotacredito" item-text="descripcion"
            :rules="[$rules.required]" v-model="Modallfiltro.documento" @blur="SelctCbDocumentoFiltro"
            @focus="CargarRDocumentoNotacredito">
            <template v-slot:prepend>
              <i style="font-size: 20px;" class="fa fa-book"></i>
            </template>
          </v-combobox>

        </v-col>

        <!-- -----------------------------  columna-1 -->
        <v-col cols="12" md="6" sm="6">

          <!----------------------------------------------  Desde -->
          <v-text-field dense outlined type="date" label="Desde*" v-model="Modallfiltro.Desde">

            <template v-slot:prepend>
              <i style="font-size: 20px;" class="fa fa-calendar"></i>
            </template>
          </v-text-field>



        </v-col>
        <!-- ----------------------------- fn columna-1 -->

        <!-- -----------------------------  columna-2 -->
        <v-col cols="12" md="6" sm="6">



          <!-------------------------------------------------- Hasta -->
          <v-text-field dense outlined type="date" label="Hasta*" v-model="Modallfiltro.Hasta">

            <template v-slot:prepend>
              <i style="font-size: 20px;" class="fa fa-calendar"></i>
            </template>

          </v-text-field>


        </v-col>
        <!-- ----------------------------- fn columna-2 -->

      </v-row>


    </v-card-text>
    <v-divider></v-divider>
    <v-card-actions>
      <v-spacer></v-spacer>

      <v-btn-toggle dense rounded class="">


        <v-btn color="#90A4AE" @click.prevent="Limpiarfiltro">
          <i style="font-size: 28px;" class="fa fa-file-o"> </i>
          Limpiar filtro
        </v-btn>

        <v-btn color="blue lighten-1" @click.prevent="BuscarFiltros">
          <i style="font-size: 28px;" class="fa fa-search"> </i>
          Buscar
        </v-btn>

      </v-btn-toggle>

    </v-card-actions>

  </v-card>
</v-dialog>
<!-------------------------------------------------------- fn Modal-Filtro tb-datos -->


<!-- fn Modales ----------------------------------------------------------------------------------------------->

<!---------------------  Panel Menu Opcion Botones style="max-height:300px;" ------------------------------->
<div class="overflow-x-auto" v-show="false">
              <!-- columna  ---------------------->
              <PvDgiiFacturacionEletronica ref="RefPvDgiiFacturacionEletronica" />
</div>

  </div>
</template>


<script>
import {currencyFormatter,FormatoFecha,HoraFormatter,fechaNueva,RedondeoValor,RedondeoBasico,RedondeoValorCantRed} from "@/js/Funciones.js";
import { EventBus } from "../../event-bus";
import BarraBusqueda2 from "../../components/BarraBusquedaDinam";
import ContenidoBase from "../../components/ContenidoBase";
import VueAutonumeric from "../../components/AutoNumericNuevo";
import PvDgiiFacturacionEletronica from "@/PuntodeVenta/UtilidadComponents/PvDgiiFacturacionEletronica.vue";
import BarraDinamicaLimitePlus from "../../components/BarraDinamicaLimitePlus";
import ComponentsPvImprecionViewer from "@/PuntodeVenta/UtilidadComponents/PvImprecionViewer.vue";
export default {
  components: {
    BarraBusqueda2,
    ContenidoBase,
    VueAutonumeric,
    PvDgiiFacturacionEletronica,
    BarraDinamicaLimitePlus,
    ComponentsPvImprecionViewer
  },

  created() {
    var json = {
      titulo: "Devolución a Clientes",
      descripcion: "Devolución a Clientes.",
      save: false,
      eliminar: false,
      anular: false,
      nuevo: false,
      imprimir: false,
      btnBarraDi:false,
      
      accion: [
        "devClientesNew",
        "devClientesSave",
        "devClientesRemove",
        "devClientesAnular",
        "devClientesPrintList"
      ], 
    };
    EventBus.$emit("anularBotonesAccion", json);
  },
  mounted() {
    EventBus.$on("abrirMenuizquierdo", this.abrirTabla);
    // EventBus.$on("abrirMenuizquierdo", this.abrirTabla2);
    // EventBus.$on("devClientesNew", this.new);
    // EventBus.$on("devClientesSave", this.save);
    // EventBus.$on("devClientesRemove", this.remove);
    // EventBus.$on("devClientesAnular", this.remove);
    // EventBus.$on("devClientesPrintList", this.imprimirList);
    EventBus.$on("emitdevClientes", this.datostabla);
    EventBus.$on("onResize", this.onResize);
  },

  data:()=>  ({
    guardandoDevolucion: false,
    guardadoDevolucionIncierto: false,
    devolucionGuardadaEnSesion: null,


    loaderTabla:false,
    arrayPropiedases: {
      'items-per-page-options': [5,10, 15, 20, 50],
      'items-per-page-text': 'Cant.de Registros Por Pag',
      showFirstLastPage: false
    },
      windowSize:{width:"auto", height:"auto"},
      RDocumentoNotacredito:[],
      RCliente:[],
      RVendedores:[],
      selectedlistFactVent:[],
      RCliente:[],
      DevolucionFacturaSeleccionada: {
      secuencia: 0,
      fecha: null,
      ncf: "",
      cliente: "",
      comentario: "",
      turno: 0,
      formapago: "",
      DetalleList: [],
      devtarjeta:false,
      efectivo:false
    },
      listFactVent:[],
      ejecucion:true,
      dialogFiltros:false,
      devClientes: {
        documentoNotaCredito:null,
        secuencia:null,
        fecha:fechaNueva(),
        ncf:null,
        cliente:null,
        vendedor:null,
        referencia:'',
        quitarItbis:false,
        datadev:null,
        soloImprimir:false
        // fechaCreacion: new,
        //  fechaModificacion: "", 
      },

  Modallfiltro: {
        codDevo: null,
        cliente: null,
        documento: null,
        Desde: null,
        Hasta: null,
        vendedores: null

      },
      ObjTemTbDinam: null,
      ListItemsBarraDin: [],
      TbTotalItemBarraDin: 0,
      TbPaginatorBarraDin: {
        page: 1,
        itemsPerPage: 5,
        pageStart: 1,
        pageStop: 15,
        pageCount: 10,
        itemsLength: 5
      },

      CierresCajas: {
      cierrescajasPK: { caja: 0, secuencia: 0 },
      cantidadtarjeta: 0,
      tarjeta: 0,
      cantidadcheques: 0,
      cheques: 0,
      cantidadrecibo: 0,
      recibos: 0,
      efectivo: 0,
      cierrecajaMonedaList: [],
      DenominacionCierrecajaList: [],
      datoTarjeta: null,
      cantidadtranferencia:0,
      transferencia:0,

    },

infCliente:{
balance:0,
telefono:''
},

totales:{
  costo:0,
  precio:0,
  existencia:0,
  valor:0
},

TotalRegistros:0,
TbPaginator: {
        page:1,
        itemsPerPage: 5,
        pageStart: 1,
        pageStop: 15,
        pageCount: 10,
        itemsLength: 5
      },



EstadoBtn:{ 
        BarraTablaDinamicaAprir:true,
        nuevo:true,
        guardar:false,
        eliminar:false,
        anular:false,
        imprimir:false,
        vercuenta:false,
        guardartemporal:false,
        restaurartemporal:false,
        importarDato:false,
        cargarProducto:false,
        ImprimirproductoInv:false,
        },



     
      text: "",
      valid: true,
     BarraTablaDinamicaAprir: false,
      BarraSecundariaAprir: false,

      headers: [{ text: "Tipo Clientes", value: "descripcion" }],

      slotlist: [
        { dt0: "codigo", dt1: null, dt2: null, dt3: 1, dt4: "Código:" },
        {
          dt0: "descripcion",
          dt1: null,
          dt2: null,
          dt3: 1,
          dt4: "Descripcion:"
        },
        { dt0: "activo", dt1: null, dt2: null, dt3: 0.1, dt4: "Desactivo" },
      ],

      slotHtabla: [
        { text: "Código", value: "codigo" },
        { text: "Descripcion", value: "descripcion" }
      ],

      list: [],
      search: "",
      acti_tb_data: false,
      Elim_notif: {
        estado: false,
        nombre: "¿Seguro que desea anular este registro?"
      },

      aalert: {
        estado: false,
        color: null
      },
    
    }),


  //   destroyed() {
  //     location.reload();
  //   },
  methods: {
currencyFormatter,FormatoFecha,HoraFormatter,fechaNueva,RedondeoValor,RedondeoBasico,RedondeoValorCantRed,

onResize(e){

this.windowSize=e


},

    abrirTabla() {
      this.BarraTablaDinamicaAprir = !this.BarraTablaDinamicaAprir;
if (this.BarraTablaDinamicaAprir == true) {
        this.Limpiarfiltro()
      }

    },
   
    datostabla(e) {
        this.selectedlistFactVent=[]
        this.listFactVent=[]
        this.TotalRegistros=0
        
        this.devClientes= {
        documentoNotaCredito:null,
        secuencia:null,
        fecha:this.fechaNueva(),
        ncf:null,
        cliente:null,
        vendedor:null,
        referencia:'',
        quitarItbis:false,
        datadev:null,
        soloImprimir:false
        // fechaCreacion: new,
        //  fechaModificacion: "", 
      }

      var DATA=JSON.parse(JSON.stringify(e))
      DATA.fecha=DATA.nuevaFecha

      //this.devClientes = e;
      this.acti_tb_data=false

      this.TotalRegistros=1
      this.listFactVent.push(e.facturasventa)
     
      var _this = this;
      setTimeout(function () {
        _this.devClientes.fecha=DATA.nuevaFecha
        _this.devClientes.ncf=DATA.ncf
         if(DATA.hasOwnProperty('vendedor')&&DATA.vendedor!=null && DATA.vendedor.hasOwnProperty('codigo')){
       _this.devClientes.vendedor= JSON.parse(JSON.stringify(DATA.vendedor))
      }

       if(DATA.facturasventa.hasOwnProperty('cliente')&&DATA.facturasventa.cliente!=null && DATA.facturasventa.cliente.hasOwnProperty('codigo')){
       _this.devClientes.cliente= JSON.parse(JSON.stringify(DATA.facturasventa.cliente))
      }

      if(DATA.hasOwnProperty('referencia')&&DATA.referencia!=null){
       _this.devClientes.vendedor= JSON.parse(JSON.stringify(DATA.referencia))
      }

      if(DATA.hasOwnProperty('notacreditoclientes') &&DATA.notacreditoclientes!=null){
      _this.devClientes.documentoNotaCredito=DATA.notacreditoclientes.documentocxc
      _this.devClientes.secuencia=DATA.notacreditoclientes.notacreditoclientesPK.secuencia
      }

      if(DATA.hasOwnProperty('notacreditocontado') &&DATA.notacreditocontado!=null){
      _this.devClientes.documentoNotaCredito=DATA.notacreditocontado.documentocxc
      _this.devClientes.secuencia=DATA.notacreditocontado.notacreditocontadoPK.secuencia

      }
        _this.devClientes.datadev=DATA
        _this.devClientes.soloImprimir=true
       _this.selectedlistFactVent.push(e.facturasventa)

       _this.DevolucionFacturaSeleccionada=JSON.parse(JSON.stringify(DATA))
        
     if(DATA.hasOwnProperty('devolucionDetalleList')&&DATA.devolucionDetalleList!=null && DATA.devolucionDetalleList.length>0){
      //_this.DevolucionFacturaSeleccionada.SeletDetalleList=JSON.parse(JSON.stringify(DATA.devolucionDetalleList))
        _this.llenarDetalleProducto(DATA)
      }
 
      }, 600);
    },

async llenarDetalleProducto(DATA){

  var LIST_DETALLE_PRODUCTO=DATA.devolucionDetalleList
  var LIST_FACTURA=DATA.facturasventa.facturasventaDetalleList




/*await Promise.all(e.facturasventaDetalleList.filter((ee) => ee.cantidadPendiente !=null && ee.cantidadPendiente>0 ).map(async (element) => { 
        element.cantidad = element.cantidadPendiente;
        objjt.DetalleList.push(element);
}));*/

await Promise.all(LIST_DETALLE_PRODUCTO.map(async (element) => { 

      element.codprod=this.GetCodigoProdUni(element)
      element.descripcion=`${element.producto.descripcion.trim()} (${element.unidad.descripcion.trim()})`
      element.valor =(element.cantidad*element.precio) 
      var procod =element.producto.codigo
      var produni =element.unidad.codigo
      var codlot = element.lote !=null && element.lote!=""?element.lote:0

      var objList= LIST_FACTURA.filter((ee) =>
        ee.productos.codigo===procod && ee.unidades.codigo===produni && ee.lote===codlot
        ); 

    if(objList.length>0){
     element.valorimpuesto=objList[0].valorimpuesto
    }else{
      element.valorimpuesto=0
    }

    element.productos= JSON.parse(JSON.stringify(element.producto))
    element.unidades = JSON.parse(JSON.stringify(element.unidad))
    //  this.DevolucionFacturaSeleccionada.valordevolucion += element.valor;
       }));

   this.DevolucionFacturaSeleccionada.SeletDetalleList=JSON.parse(JSON.stringify(LIST_DETALLE_PRODUCTO)) 

   this.loaderTablaCargar()
    this.DevolucionValorTotal()
},


GetCodigoProdUni(ELEMENTO) {
      var pkproducto=ELEMENTO.producto.codigo;
      var pkunidad=ELEMENTO.unidad.codigo;
      var codigoP = ('000000' + pkproducto).substring(('000000' + pkproducto).length - 6, ('000000' + pkproducto).length)
      var codigoU = ('0000' + pkunidad).substring(('0000' + pkunidad).length - 4, ('0000' + pkunidad).length)
    
      var codigoLote = "";
      if (this.$store.getters.GetConfiguracionGeneral.configInv.usarLote) {
        if (ELEMENTO.lote!=null && ELEMENTO.lote.trim()!== "") {
          codigoLote = ELEMENTO.lote
        }
      }

      var codigoBarra = codigoP + codigoU + codigoLote;
      if (this.$store.getters.GetConfiguracionGeneral.configInv.usarLote && codigoBarra.length > 14) {
        codigoBarra = codigoBarra.substring(0, 14)
      }
      return codigoBarra
    },



    save() { },
    remove() { },
    eliminar() { },
    anular() { },
    imprimirList() {


//fac.factura.devolucion
var DEV =JSON.parse(JSON.stringify(this.devClientes.datadev)) 
  /*   var DEVDATAA={
      factura:{
        devolucion:this.devClientes.datadev
      }
     }
     
     //
DEVDATAA.factura.devolucion.caja=0*/
      DEV.caja=0
  var Config = this.$store.getters.GetConfiguracionGeneral
  /**/var _this = this;
setTimeout(function () { 
 // _this.alerta("Devolucion salvada correctamente !!!", "bien");
            if (localStorage.printerSelect != null) { }
            var selectImpre=(localStorage.printerSelect!=undefined?JSON.parse(localStorage.printerSelect):null)
            var impresora=null
            if(selectImpre!=null && selectImpre.hasOwnProperty('nombre')){
              impresora=JSON.parse(localStorage.printerSelect).nombre
              }
              var msg = {
                accion: "print",
                formato: DEV.facturasventa.caja.formatoimpresioncontado.trim(),
                impresora: impresora,
                data: Config,
                devolucion: DEV,
                caja: DEV.facturasventa.caja,
                cajero: _this.$store.getters.GetOtrasConfigPv.cajero,
              };
              _this.imprimir(msg, "devolucion");
            //_this.newwnuevo();
}, 100);
this.devClientes.datadev

    },
    newwnuevo() {
      if (this.guardandoDevolucion || this.guardadoDevolucionIncierto) return;
      this.devolucionGuardadaEnSesion = null;

this.selectedlistFactVent=[]
this.listFactVent=[]
this.devClientes= {
        documentoNotaCredito:null,
        secuencia:null,
        fecha:fechaNueva(),
        ncf:null,
        cliente:null,
        vendedor:null,
        referencia:'',
        quitarItbis:false,
        datadev:null,
        soloImprimir:false
        // fechaCreacion: new,
        //  fechaModificacion: "", 
      },

this.DevolucionFacturaSeleccionada= {
      secuencia: 0,
      fecha: null,
      ncf: "",
      cliente: "",
      comentario: "",
      turno: 0,
      formapago: "",
      DetalleList: [],
      devtarjeta:false,
      efectivo:false
    },

      

this.totales={
  costo:0,
  precio:0,
  existencia:0,
  valor:0
}

this.TotalRegistros =0
this.listFactVent=[]

this.CierresCajas= {
      cierrescajasPK: { caja: 0, secuencia: 0 },
      cantidadtarjeta: 0,
      tarjeta: 0,
      cantidadcheques: 0,
      cheques: 0,
      cantidadrecibo: 0,
      recibos: 0,
      efectivo: 0,
      cierrecajaMonedaList: [],
      DenominacionCierrecajaList: [],
      datoTarjeta: null,
      cantidadtranferencia:0,
      transferencia:0,

    }

    this.ejecucion=true
    EventBus.$emit("loading", false);
     //   EventBus.$emit("actualizaBarraBusqueda2");
    },

    // Hacer una solicitud al servidor y obtener los datos del servidor.
    CargarRDocumentoNotacredito() {

 this.$axios.get(this.$hostname + this.$hName + '/documentocxc/findallCXCNotaCredito', { headers: this.$store.getters.GetheadersAxios })
        .then(res => (this.RDocumentoNotacredito = res.data))

      this.$axios.get(this.$hostname + this.$hName +"/documento-inv/devolucion",
        { headers: this.$store.getters.GetheadersAxios })
        .then(res => {
          this.RDocumentoDevoluc = res.data;
        });
    },

    // Comprobando si el documentoNotaCredito es nulo o indefinido.
    SelectCbDocNotacredito() {
      var _this = this;
      setTimeout(function () {
        if (_this.devClientes.documentoNotaCredito == null) {
          _this.devClientes.documentoNotaCredito = "";
        }

        if (!_this.devClientes.documentoNotaCredito.hasOwnProperty('codigo')) {
          _this.devClientes.documentoNotaCredito = "";
          _this.devClientes.documentoNotaCredito = null;
          return;
        }
      }, 300);
    },

  changeCbNotaCredito(e){

  if ( typeof e === 'object' && e!= null) {
 this.$axios.get(this.$hostname +this.$hName +"/notacreditocliente/ultimoSecuenciaCxCnotacredito/"+
          e.operaciones.codigo +"/"+e.codigo,
          { headers: this.$store.getters.GetheadersAxios })
        .then((res) => {
          this.devClientes.secuencia=res.data
        });
  }else{
    this.devClientes.secuencia=null
  }
},


cargarCliente(){
this.$axios.get(this.$hostname+this.$hName+'/clientes/findtodo/a/3/25/0',{headers:this.$store.getters.GetheadersAxios})
.then(res=>( this.RCliente=res.data))
},



CbFilcliente(e) {  
if (e.target.value.length >= 0) {
          this.$axios
            .get(
              this.$hostname +
                this.$hName +
                "/clientes/findtodo/" +
                (e.target.value === null || e.target.value.length==0 ? 'A' : e.target.value)  +
              "/3/25/0",
              {headers:this.$store.getters.GetheadersAxios}
            )
            .then(res => (this.RCliente = res.data));
        }
      
      
    },

     SelctCbCliente() {
      var _this = this;
      setTimeout(function () {
        if (_this.devClientes.cliente == null) {
          _this.devClientes.cliente = "";
        }

        if (!_this.devClientes.cliente.hasOwnProperty('codigo')) {
          _this.devClientes.cliente = "";
          _this.devClientes.cliente = null;
          return;
        }

      _this.getFacVenta()

      }, 300);
    },

changeCbCliente(e){
  if ( typeof e === 'object' && e!= null) {
    this.getFacVenta()
  }else{
    this.TotalRegistros =0
     this.listFactVent=[]
  }
},


    // Llamar a la API y obtener los datos de la API.
    cargarVendedores() {
      let headers = this.$store.getters.GetheadersAxios
      this.$axios
          .get(this.$hostname + this.$hName + '/vendedores/findallactiv', {headers})
          .then(res => (this.RVendedores = res.data))
    },


SelctCbVendedores() {
      var _this = this;
      setTimeout(function () {
        if (_this.devClientes.vendedor == null) {
          _this.devClientes.vendedor = "";
        }

        if (!_this.devClientes.vendedor.hasOwnProperty('codigo')) {
          _this.devClientes.vendedor = "";
          _this.devClientes.vendedor = null;
          return;
        }
      }, 300);
    },



ObtenerFormaDepago(e) {
      var Fpago = '';

      if (e.hasOwnProperty("puntos") && e.puntos > 0) {
        Fpago = "Puntos"
        return Fpago;
      }

      if (e.hasOwnProperty("cxc") && e.cxc > 0) {
        Fpago = "Cuenta Por Cobrar"
        return Fpago;
      }

      if (e.hasOwnProperty("tarjeta") && e.tarjeta > 0) {
        Fpago = "Tarjeta de Credito"
        return Fpago;
      }

      if (e.hasOwnProperty("cheques") && e.cheques > 0) {
        Fpago = "Cheques"
        return Fpago;
      }

      if (e.hasOwnProperty("transferencia") && e.transferencia > 0) {
        Fpago = "Transferencia"
        return Fpago;
      }

      if (e.hasOwnProperty("efectivo") && e.efectivo > 0) {
        Fpago = "Efectivo"
        return Fpago;
      }

      return Fpago;

    },

    
      DevolucionObtenerDatoSelect(e) {
        this.DevolucionDatostabla(e.item)
      },

DevolucionDatostabla(e){
  var _this = this;
    setTimeout(function(){ 
  _this.contDevolucionDatostabla(e)
                }, 500); 

},
    async contDevolucionDatostabla(e) {
      this.selectedlistFactVent=[]
      this.devClientes.vendedor=null

         if(e.hasOwnProperty('cobertura')&&e.cobertura!=null&&e.cobertura>0){
        this.alerta("No puede hacer una devolución de esta factura porque es de seguro. esta se debe anular", "error");
        this.selectedlistFactVent = [];
        return
      }

      if(e.hasOwnProperty('domicilio') && e.domicilio!=null && e.domicilio.facturado==false ){
        if(e.domicilio.hasOwnProperty('mensajero')&& e.domicilio.mensajero!=null){
        this.alerta("No puede hacer una devolución de esta factura porque esta asignada a un mensajero. se debe realizar el proceso de no entregada", "error");
        this.selectedlistFactVent = [];
        return
        }
      }

      if(e.hasOwnProperty('vendedor')&&e.vendedor!=null && e.vendedor.hasOwnProperty('codigo')){
       this.devClientes.vendedor= JSON.parse(JSON.stringify(e.vendedor))
      }

      this.selectedlistFactVent = [];
      var objjt = {
        factcaja:e.caja,
        valordevolucion: 0,
        valortotal: e.valor,
        secuencia: e.facturasventaPK.secuencia,
        //fecha: new Date(e.fecha).toISOString().substr(0, 10),
        fecha: e.nuevaFecha,
        ncf: e.ncf,
        cliente: e.cliente == null ? "" : e.cliente.nombre,
        cedula: e.cliente != null ? e.cliente.cedrnc : "",
        comentario: "",
        turno: e.turno,
        formapago: this.ObtenerFormaDepago(e),
        DetalleList: [],
        SeletDetalleList: [],
        efectivo: false,
        quitaritbis: false,
        moneda:e.moneda,
        tasa:e.tasa,
        domicilio:e.hasOwnProperty("domicilio")?e.domicilio:null,
        cheques:e.hasOwnProperty("cheques") && e.cheques != null ? e.cheques : 0,
        cupones:e.hasOwnProperty("cupones") && e.cupones != null ? e.cupones : 0,
        cxc: e.hasOwnProperty("cxc") && e.cupones != null ? e.cxc : 0,
        Pagoefec:e.hasOwnProperty("efectivo") && e.cupones != null ? e.efectivo : 0,
        puntos: e.hasOwnProperty("puntos") && e.puntos != null ? e.puntos : 0,
        tarjeta:e.hasOwnProperty("tarjeta") && e.tarjeta != null ? e.tarjeta : 0,
        valorNc:e.hasOwnProperty("valorNc") && e.valorNc != null ? e.valorNc : 0,
        transferencia:e.hasOwnProperty("transferencia") && e.transferencia != null ? e.transferencia : 0,
        numerocierre:e.numerocierre,
        devtarjeta:false,
        qrdgii:e.hasOwnProperty("qrdgii") && e.qrdgii != null ? e.qrdgii : null,
        signatureValue:e.hasOwnProperty("signatureValue") && e.signatureValue != null ? e.signatureValue : null,
        trackId:e.hasOwnProperty("trackId") && e.trackId != null ? e.trackId : null,
        fechafirmadgii:e.hasOwnProperty("fechafirmadgii") && e.fechafirmadgii != null ? e.fechafirmadgii : null
      };
      //DetalleList:e.facturasventaDetalleList,
      //e.facturasventaDetalleList.forEach((element) => { });





      await Promise.all(e.facturasventaDetalleList.filter((ee) => ee.cantidadPendiente !=null && ee.cantidadPendiente>0 ).map(async (element) => { 
        element.cantidad = element.cantidadPendiente;
        objjt.DetalleList.push(element);
}));
      

      this.selectedlistFactVent.push(e);
      this.DevolucionFacturaSeleccionada = objjt;

      var fechaHoy= this.fechaNueva()
      var fechBase=e.nuevaFecha
      var fechNew=new Date(e.nuevaFecha)
      fechNew.setDate(fechNew.getDate() + 30);
      fechNew =new Date(fechNew).toLocaleDateString("en-CA")
      var _this = this;
    setTimeout(function(){ 
      if(fechaHoy>fechNew){
      _this.devClientes.quitarItbis=true
        _this.alerta(`La factura pasa de los 30 días de su emisión ${_this.FormatoFecha(e.nuevaFecha)}, se recomiendo quitar el itbis`, "error")
      _this.DevolucionFacturaSeleccionada.quitaritbis=true
      _this.DevolucionValorTotal()
      }else{
          _this.devClientes.quitarItbis=false
      }
      _this.addNewListDevolucion()
                }, 500); 

      },

cargarPaginacion(e) {
      this.TbPaginator = JSON.parse(JSON.stringify(e));
      this.getFacVenta()
    },
getFacVenta() {
/*
busquedaFacVent: {
        cliente: null,
        fechaInicial: fechaNueva(),
        fechaFinal: fechaNueva(),
        NoFactura: 0,
        documento: null,
        ncf: null,
      },
*/ 

        if (this.$refs.formFactVenta.validate()) {

          var obj = {
            fechaInicial:null,
            fechaFinal:null
          }
          //JSON.parse(JSON.stringify(this.devClientes))
          if (this.devClientes.documento != null) {
            obj.documento = this.devClientes.documento.codigo
          }
          if (this.devClientes.cliente != null) {
            obj.cliente = this.devClientes.cliente.codigo
          }
          obj.limit = this.TbPaginator.itemsPerPage
          obj.ultimo = this.TbPaginator.pageStart

          this.$axios
            .post(this.$hostname + this.$hName + "/facturasventas/FindDevolucionClientes", obj, {
              headers: this.$store.getters.GetheadersAxios,
            })
            .then((res) => {
              ;(this.TotalRegistros = res.data.TbTotalItem), (this.listFactVent = res.data.ListFactura)
            })
            .catch((error) => {
              this.alerta("Reporte no Impreso(" + error + ")", "error")
            })
        } else {
          this.alerta("Los campos en rojo son requeridos", "error")
        }
      },



SelcDevObtenerDatoSelect(e) {
      // @item-selected="DevolucionObtenerDatoSelect"
      if (e.value == true) {
        if (e.item.cantidadPendiente == 0) {
          var _this = this;
          setTimeout(function () {
            const index = _this.DevolucionFacturaSeleccionada.SeletDetalleList.indexOf(e.item);
            _this.DevolucionFacturaSeleccionada.SeletDetalleList.splice(index, 1);
          }, 200);
          this.alerta("no puede hacer una devolución a un producto con la cantidad en 0", "error");

        }


      }

      var _this = this;
      setTimeout(function () { _this.DevolucionValorTotal() }, 400);
    },


async DevolucionValorTotal() {
      this.DevolucionFacturaSeleccionada.valordevolucion = 0
 var _this = this;
      setTimeout(function () {
       if (_this.DevolucionFacturaSeleccionada.SeletDetalleList.length > 0) {
       Promise.all(_this.DevolucionFacturaSeleccionada.SeletDetalleList.map(async (element) => { 
          _this.DevolucionFacturaSeleccionada.valordevolucion += element.valor;
       }));
      } 
      }, 500);
    },

    async AllSelcDevObtenerDatoSelect(e) {
    
          if (e.value == true) {
    
            var _this = this;
            setTimeout(function () {
    
              _this.DevolucionFacturaSeleccionada.SeletDetalleList.forEach(element => {
    
                if (element.cantidadPendiente == 0) {
                  const index = _this.DevolucionFacturaSeleccionada.SeletDetalleList.indexOf(element);
                  _this.DevolucionFacturaSeleccionada.SeletDetalleList.splice(index, 1);
                  _this.alerta("no puede hacer una devolución a un producto con la cantidad en 0", "error");
                }
    
              });
            }, 200);
    
          }
    
          var _this = this;
          setTimeout(function () { _this.DevolucionValorTotal() }, 400);
    
        },

    DevolucionValor(e) {
          if(e.productos==null){
            return 0;
          }
      //DevolucionFacturaSeleccionada.DetalleList
      //this.RedondeoBasico(this.Facturasventa.tarjeta)
      //this.DevolucionFacturaSeleccionada.quitaritbis
      var itbisTasa = 0.00;
      var itbis = 0.00;
      var descuento = 0.00;
      var descuentoValor = 0.00;
      var precioSinItbis = 0.00;
      var valor = 0.00;
      if (e.productos.impuesto != null) {
        itbisTasa = e.productos.impuesto.tasa;
      }
      if (e.valordescuento > 0) {
          var DESCUENTOVALOR= this.devolucionDescuento(e)
        descuentoValor = this.RedondeoValor(DESCUENTOVALOR / e.cantidad);
      }
      if (e.descuento > 0) {
        if (itbisTasa > 0) {
          if (e.productos.incluirimpuestoenprecio) {
            descuento = e.cantidad * this.RedondeoValor(((e.precio / (1 + (itbisTasa / 100))) * (e.descuento / 100)));
            precioSinItbis = e.cantidad * this.RedondeoValor((e.precio / (1 + (itbisTasa / 100))));
            itbis = this.RedondeoValor((precioSinItbis - descuento) * (itbisTasa / 100));
           
            //if(this.DevolucionFacturaSeleccionada.quitaritbis) {
            if(e.quitaritbis) {
              itbis = 0;
            }

            valor = (precioSinItbis - descuento) + itbis;
          } else {
            descuento = e.cantidad * this.RedondeoValor((e.precio * (e.descuento / 100)));
            precioSinItbis = e.cantidad * this.RedondeoValor(e.precio);
            itbis = this.RedondeoValor((precioSinItbis - descuento) * (itbisTasa / 100));
          //  if (this.DevolucionFacturaSeleccionada.quitaritbis) {
          if(e.quitaritbis) {
              itbis = 0;
            }
            valor = (precioSinItbis - descuento) + itbis;
          }
        } else {
          if (descuentoValor > 0) {
            valor = (e.cantidad * e.precio) - (e.cantidad * descuentoValor);
          } else {
            valor = e.cantidad * (e.precio) * (e.descuento / 100);
          }
        }
      } else {

        //if (this.DevolucionFacturaSeleccionada.quitaritbis) {
         if(e.quitaritbis) {
          if (e.valorimpuesto > 0) {
            valor = e.cantidad * (e.precio - e.valorimpuesto);
          } else {
            valor = e.cantidad * (e.precio);
          }
        } else {
          valor = e.cantidad * e.precio;
        }
      }
      if(this.$store.getters.GetConfiguracionGeneral.configPv.impuestoincluido==true){
        e.valor = this.RedondeoValorCantRed(valor,2);
      }else{
        e.valor =this.RedondeoValorCantRed((valor+(e.valorimpuesto*e.cantidad)),2)
      }
      
      return e.valor  ;
    },

    KeyUpCantidad(e) {

      //  if(e.key.charCodeAt(0)>=48 & e.key.charCodeAt(0)<=57 ){}

      if (e.target.value.length == 0) {
        e.target.value = 0
      }

      if (e.key) {
        var mynumeral = require("numeral")
        e.target.value = mynumeral(e.target.value).value()

        //console.log(mynumeral(""+this.mensajero.metadeenvios)).value()
        if (e.target.value == null) {
          e.target.value = 0
        }
      } else {
        e.key = ""
      }

      if (e.target.value.length == 0) {
        e.target.value = 0
        e.key = 0
      }
    },

currencyFormatter2TasaInf(value,tasaSelec) {
     var thisTasaMoneda=1
var MONEDA=JSON.parse(JSON.stringify(this.$store.getters.GetConfiguracionGeneral.config.monedabase))
var MONEDAFACTURA= (tasaSelec!=null?tasaSelec:MONEDA.tasa )
var CANTREDONDEO=(MONEDAFACTURA!=MONEDA.tasa?4:2)

return (
 "" +
 parseFloat(this.RedondeoValorCantRed(value / thisTasaMoneda,CANTREDONDEO)).toLocaleString("en",{ minimumFractionDigits: CANTREDONDEO })
);


},

getTasaInfo(valor,tasaSelect){
 var BVALOR=0
  var MONEDA=JSON.parse(JSON.stringify(this.$store.getters.GetConfiguracionGeneral.config.monedabase))
  var MONEDAFACTURA= (tasaSelect!=null?tasaSelect:MONEDA.tasa )
  BVALOR=((MONEDA.tasa/MONEDAFACTURA)*valor)
  return BVALOR;
},

 DevolucionVerificaCantidad(e) {
      if (e.cantidad > e.cantidadPendiente) {
        e.cantidad = e.cantidadPendiente;
      }
      if (e.cantidad <= 0) {
        e.cantidad = e.cantidadPendiente;
      }
    },

addNewListDevolucion(){

  var OBJ={
  codprod:"",
  descripcion:"",
  productos:null,
  unidades:null,
  cantidad:0,
  precio:0,
  valorimpuesto:0,
  valor:0,
  quitaritbis:false
  }

  this.DevolucionFacturaSeleccionada.SeletDetalleList.push(OBJ)

},


SeachFilkeyEnterProd(e){
this.$axios
          .get(this.$hostname + this.$hName + "/producto/findListProductoPlus", {
            headers: this.$store.getters.GetheadersAxios,
            params: {
              producto: e.codprod,
              limit: 3,
              ultimo: 0
            }
          })
          .then((res) => {
          if(res.data.ListItems.length>0 && (e.codprod.trim())===(res.data.ListItems[0].codigobarra!=null?res.data.ListItems[0].codigobarra.trim():"")){
            this.contSeachFilkeyEnterProd(e, res.data.ListItems[0].productos.codigo, res.data.ListItems[0].unidades.codigo)
            }else{
              this.contSeachFilkeyEnterProd(e,0,0)
            }
          })
},


contSeachFilkeyEnterProd(e,barpro,baruni){

     /* if(!isNaN(e.codprod) && typeof e.codprod === 'number'){
          console.log('Es un numeroo klk--->')
      }*/
      var codpro=0,codant=0,procod=0,produni=0,codlot=0
      var codigobarra = e.codprod

          //PRODUCTO 
          if (e.codprod.length <= 9){
            codpro= e.codprod
            }

        //PRODUCTO Y UNIDAD
        if (e.codprod.length == 10){
            procod = parseInt(e.codprod.substring(0, 6)) 
            produni = parseInt(e.codprod.substring(6, 10))
         }

         //PRODUCTO UNIDAD LOTE
         if (e.codprod.length == 14) {
           procod = parseInt(e.codprod.substring(0, 6))
           produni = parseInt(e.codprod.substring(6, 10))
           codlot=  parseInt(e.codprod.substring(10, 14))
         }

     var ObjProRow = this.DevolucionFacturaSeleccionada.DetalleList.filter((ee) => 
     ee.productos.codigo===codpro ||  ee.productos.codigo===procod && ee.unidades.codigo===produni && ee.lote===codlot
     || ee.productos.codigo===barpro && ee.unidades.codigo===baruni
    ); 


     if(ObjProRow.length>0){
       var  OBJEDIT=this.DevolucionFacturaSeleccionada.SeletDetalleList.filter((ee) => ee.codprod ===e.codprod );
       if(OBJEDIT.length>0){
        const UNION_OBJ = Object.assign(OBJEDIT[0], ObjProRow[0]);
        UNION_OBJ.quitaritbis=this.devClientes.quitarItbis
        OBJEDIT[0]=JSON.parse(JSON.stringify(UNION_OBJ));

        var  OBJNEW=this.DevolucionFacturaSeleccionada.SeletDetalleList.filter((ee) => ee.productos ===null );
        if(OBJNEW.length==0){
          this.addNewListDevolucion()
        }
       }  
     }else{

      // var  OBJEDIT=this.DevolucionFacturaSeleccionada.SeletDetalleList.filter((ee) => ee.codprod ===e.codprod && ee.indx==e.indx);
     var OBJ={
  indx :e.indx,
  codprod:e.codprod,
  descripcion:"",
  productos:null,
  unidades:null,
  cantidad:0,
  precio:0,
  valorimpuesto:0,
  valor:0,
  quitaritbis:this.devClientes.quitarItbis
  }

   let INDX_PRO =this.DevolucionFacturaSeleccionada.SeletDetalleList.findIndex((ee) => ee.codprod ===e.codprod && ee.indx===e.indx);
   this.DevolucionFacturaSeleccionada.SeletDetalleList[INDX_PRO]=OBJ
  this.alerta("El código colocado no pertenece a ningún producto de la factura seleccionada", "error");
     }

     this.loaderTablaCargar()
   
 },

  
    changeItbisProd(item){
     // this.devClientes.quitarItbis
     var _this = this;
    setTimeout(function(){ 
if(_this.devClientes.quitarItbis==true){
  item.quitaritbis=true
  _this.alerta(`La factura pasa de los 30 días de su emisión ${_this.FormatoFecha(_this.DevolucionFacturaSeleccionada.fecha)}, se recomiendo quitar el itbis`, "error")
      }
      _this.DevolucionValorTotal()
                }, 500);


    },




 // Crear un nuevo objeto y asignarle valores.
    async FinalizarDevolucionFactura() {

var ObjProRowSe = this.DevolucionFacturaSeleccionada.SeletDetalleList.filter((ee) => ee.hasOwnProperty('productos')&& ee.productos!=null);
    //  if (this.DevolucionFacturaSeleccionada.SeletDetalleList.length == 0) {
    if (ObjProRowSe.length == 0) {
        this.alerta("Seleccione al menos 1 producto", "error");
        return 0;
      }

      var ObjProRow = this.DevolucionFacturaSeleccionada.SeletDetalleList.filter((ee) => ee.hasOwnProperty('productos')&& ee.productos!=null&&ee.cantidadPendiente == 0);

      if (ObjProRow.length > 0) {
        this.alerta("no puede hacer una devolución a un producto con la cantidad en 0", "error");
        return 0;
      }
console.log('LOl--->',this.DevolucionFacturaSeleccionada)

      if(this.DevolucionFacturaSeleccionada.signatureValue!=null){
        // var BOOL_FACELEC=this.DevolucionFacturaSeleccionada.signatureValue!=null && this.caja.facturacionEletronica !=true && this.caja.sucursal.facturacionEletronica!=true
      var BOOL_FACELEC= this.DevolucionFacturaSeleccionada.factcaja.facturacionEletronica===true && this.DevolucionFacturaSeleccionada.factcaja.sucursal.facturacionEletronica===true
      if(BOOL_FACELEC==false){
      this.alerta("NOTA: Esta factura fue generada con comprobante eletronico y la caja/sucursal no esta asignada con facturación electronica", "error");
      return
      }
      }

      if(this.ejecucion==true){
         this.ejecucion=false  
          var _this=this;

          // this.CierresCajas.cierrescajasPK.secuencia = 0;   
        setTimeout(function(){ 
          _this.continuandoFinalizarDevolucionFactura() 
        }, 300);

        }
    },
   
     async continuandoFinalizarDevolucionFactura() {
var DEV_FAC_SEL=this.selectedlistFactVent[0]

  if(DEV_FAC_SEL.hasOwnProperty('domicilio') && DEV_FAC_SEL.domicilio!=null && DEV_FAC_SEL.domicilio.facturado==false){
  var BOOLMEN=(!DEV_FAC_SEL.hasOwnProperty('mensejero') || DEV_FAC_SEL.hasOwnProperty('mensejero') && DEV_FAC_SEL.mensejero==null )
  if(BOOLMEN==true ){
    if(DEV_FAC_SEL.DetalleList.length!= DEV_FAC_SEL.SeletDetalleList.length || DEV_FAC_SEL.valortotal!=DEV_FAC_SEL.domicilio.valor ){
      this.alerta('Esta factura es de domicilio y no esta asignada a un mensajero, debe de anular o hacer la devolución completa.', "error");
      return
    }
  }

  }
  

      EventBus.$emit("loading", true);
      //var l = this.DevolucionSelected[0];
      var l = JSON.parse(JSON.stringify(DEV_FAC_SEL));
      if(l.hasOwnProperty('horaFactura')){
          delete l["horaFactura"]
      }
      

      var domnoentre=null
        if(this.DevolucionFacturaSeleccionada.hasOwnProperty('domicilionoentregado')&&this.DevolucionFacturaSeleccionada.domicilionoentregado!=null){
          domnoentre=this.DevolucionFacturaSeleccionada.domicilionoentregado
        }


     var ObjBOOLquitaritbis = this.DevolucionFacturaSeleccionada.SeletDetalleList.filter((ee) => ee.hasOwnProperty('productos')&& ee.productos!=null&&ee.quitaritbis == true);
    // this.devolucion = 
// console.log('viendo-FACT->',DEV_FAC_SEL)

      var devolucion = {
        devoclucionPK: { documento: 0, secuencia: 0 },
        // fecha: new Date(),
        fecha: fechaNueva().trim().substr(0,10)+"T04:00",
        referencia: "",
        valor: 0.0,
        valorItbis: 0.0,
        usuario: this.$store.getters.GetdatosInfUsu.usuario.codigo,
        ncf: "",
        caja:null,
       // caja: this.caja.codigo,
        // numerocierre: this.CierresCajas.cierrescajasPK.secuencia,
        numerocierre: null,
       // efectivo: this.DevolucionFacturaSeleccionada.efectivo,
        efectivo: false,
        // quitaritbis: this.DevolucionFacturaSeleccionada.quitaritbis,
        quitaritbis: ObjBOOLquitaritbis.length>0,
        cobertura: null,
        fechaImpresion: null,
        nif: null,
        horaImpresion: null,
        comentario: this.DevolucionFacturaSeleccionada.comentario,
        borrado: false,
        devolucionDetalleList: [],
        facturasventa: l,
        nombre: this.devClientes.cliente.nombre.trim(),
        cedula: this.devClientes.cliente.cedrnc.trim(),
        notacreditocontado: null,
        notacreditoclientes: null,
        documentoinventario: null,
       // almacen: this.caja.almacen,
        almacen:DEV_FAC_SEL.caja.almacen,
        activo: true,
        domicilionoentregado: domnoentre,
        moneda:this.DevolucionFacturaSeleccionada.moneda,
        tasa:this.DevolucionFacturaSeleccionada.tasa,
        devtarjeta:this.DevolucionFacturaSeleccionada.devtarjeta,
        qrdgii:null,
        signatureValue:null,
        trackId:null,
        fechafirmadgii:null
      };

     // this.devolucion.devolucionDetalleList = [];
    var UsarLote = this.$store.getters.GetConfiguracionGeneral.configInv.usarLote



//&&ee.cantidadPendiente > 0
     await Promise.all(this.DevolucionFacturaSeleccionada.SeletDetalleList.
    filter((ee) => ee.hasOwnProperty('productos')&& ee.productos!=null&&ee.cantidad > 0).map(async (d) => { 
      //this.detalleDevolucion(d);

      var det = {
        cantidad: d.cantidad,
        precio: d.precio,
        costo: d.costounidad,
        codigo: 0,
        documentofactura: null,
        borrado: false,
        producto: d.productos,
        unidad: d.unidades,
        quitaritbis:d.quitaritbis
      };
      if(UsarLote==true){
        det.lote=datos.lote
      }

        devolucion.devolucionDetalleList.push(det);

        devolucion.valor = devolucion.valor + d.valor;
      if(d.quitaritbis==true){
          devolucion.valorItbis=0
      }else{
        devolucion.valorItbis=devolucion.valorItbis+(d.cantidad*d.valorimpuesto)
        //this.devolucion.valorItbis = this.devolucion.valorItbis + d.valor;
      }
     }));

     //this.saveDevolucion();
     this.preValidarSaveDevolucion(devolucion);

    },

async detalleDevolucion(datos) {
   var UsarLote = this.$store.getters.GetConfiguracionGeneral.configInv.usarLote
      var det = {
        cantidad: datos.cantidad,
        precio: datos.precio,
        costo: datos.costounidad,
        codigo: 0,
        documentofactura: null,
        borrado: false,
        producto: datos.productos,
        unidad: datos.unidades,
      };
      if(UsarLote==true){
        det.lote=datos.lote
      }

      this.devolucion.devolucionDetalleList.push(det);
    },


preValidarSaveDevolucion(devolucion){

  // this.devolucion
  this.$axios.post(
            this.$hostname + this.$hName + "/devolucion/verificarDevolucion",
            devolucion,
            { headers: this.$store.getters.GetheadersAxios }
          )
          .then((res) => {
          if(res.data.continuarDev==false){
            this.alerta(res.data.mensage, res.data.estado) 
 //DevolucionFacturaSeleccionada.SeletDetalleList
            //DevolucionFacturaSeleccionada.DetalleList

            this.DevolucionFacturaSeleccionada.SeletDetalleList.filter((ee) => ee.facturasventaDetallePK.producto == res.data.producto &&
            ee.facturasventaDetallePK.unidad == res.data.unidad &&
            ee.facturasventaDetallePK.secuencia == res.data.secFac &&
            ee.facturasventaDetallePK.documento == res.data.docFac 
            )[0].cantidadPendiente= res.data.catPendiente;
         
            this.DevolucionFacturaSeleccionada.DetalleList.filter((ee) => ee.facturasventaDetallePK.producto == res.data.producto &&
            ee.facturasventaDetallePK.unidad == res.data.unidad &&
            ee.facturasventaDetallePK.secuencia == res.data.secFac &&
            ee.facturasventaDetallePK.documento == res.data.docFac 
            )[0].cantidadPendiente= res.data.catPendiente;
           
          }
          if(res.data.continuarDev==true){ 
              this.saveDevolucion(devolucion)
          }

          })
          .catch((error) => {
            this.loading(false)
            if (error.response) {
              this.alerta(error.response.request.responseText, "error");
            } else {
              this.alerta(error, "error");
            }
          });

},

 // Envío de una solicitud POST al servidor guardando la devolucion.
    saveDevolucion(devolucion) {

      //var doc=this.caja.sucursal

      //console.log(devolucion.facturasventa)

      /*console.log('info-SUCURSAL->',this.caja.sucursal)
      console.log('info-FACTURA->',this.devolucion)
      devClientes.documentoNotaCredito*/

var DOC_NOTACREDITO_CXC=this.devClientes.documentoNotaCredito
var SUCURSAL= devolucion.facturasventa.caja.sucursal
var CAJA= devolucion.facturasventa.caja
if (devolucion.devolucionDetalleList.length > 0) { 

            if(DOC_NOTACREDITO_CXC.comprobante==true){
          //-->/secuenciaComprobantes/existesecuencia/
        // var link = resdoc.data.codigo +"/" + "CXC"
        var link = DOC_NOTACREDITO_CXC.codigo +"/" + "CXC/"+SUCURSAL.rnc.trim()
        this.$axios.get(this.$hostname + this.$hName + "/secuenciaComprobantes/existesecuenciaRnc/" + link,
          { headers: this.$store.getters.GetheadersAxios })
          .then(res => {
            if (res.data == true) {

        var docDev=SUCURSAL.documentoDevolucion
      this.$axios.get(this.$hostname + this.$hName +"/documento-inv/"+docDev,
          { headers: this.$store.getters.GetheadersAxios }).then(resdocInv => {
 var BOOL_ELET= SUCURSAL.facturacionEletronica==true && CAJA.facturacionEletronica==true;

if(BOOL_ELET==true && resdocInv.data.comprobante==false){
  this.alerta(`Nota: Esta caja esta asignada como facturador electrónico y el documento: "${resdocInv.data.nombrecorto}- ${resdocInv.data.descripcion}". no genera comprobante.`,"error")
  return
}

var _this = this;
    setTimeout(function(){ 
      _this.ContinuarsaveDevolucion(devolucion)
                }, 600); 

 })
.catch(error => { 
        this.alerta(error, "error")
        this.loading(false)
           });

            } else {
              this.alerta("No posee secuencia para la Notas de Crédito que está intentado realizar", "error")
            }
          })
          .catch(error => { 
        this.alerta(error, "error")
        this.loading(false)
      
           });

      }else{
        this.ContinuarsaveDevolucion(devolucion)
      }

          }else{
        this.ejecucion = true
        EventBus.$emit("loading", false);
          }


    //  var doc=this.caja.sucursal.documentoNotaCredito

      /*this.$axios.get(this.$hostname + this.$hName +"/documentocxc/find/"+doc,
          { headers: this.$store.getters.GetheadersAxios }
        ).then(resdoc => {
        });*/
    },
         
async ContinuarsaveDevolucion(devolucion) {
      if (this.guardandoDevolucion) return;
      if (this.devolucionGuardadaEnSesion || this.guardadoDevolucionIncierto) {
        this.alerta(this.devolucionGuardadaEnSesion
          ? 'La devolucion ' + this.devolucionGuardadaEnSesion + ' ya esta guardada. Consulte su estado; no vuelva a registrarla.'
          : 'No se pudo confirmar el guardado anterior. Consulte las devoluciones antes de repetir.', 'error');
        return;
      }
      
      if (!devolucion.devolucionDetalleList.length) { this.loading(false); return; }
      devolucion.documentocxcNotacredito = this.devClientes.documentoNotaCredito;
      this.guardandoDevolucion = true;
      this.loading(true);
      var headers = Object.assign({}, this.$store.getters.GetheadersAxios);
      try {
        this.guardadoDevolucionIncierto = true;
        var res = await this.$axios.post(this.$hostname + this.$hName + '/devolucion/saveDevCxC', devolucion, { headers, timeout: 30000 });
        var guardada = res && res.data;
        if (!guardada || !guardada.devoclucionPK || !guardada.devoclucionPK.secuencia) throw new Error('La API no devolvio el numero de devolucion.');
        this.guardadoDevolucionIncierto = false;
        this.devolucionGuardadaEnSesion = guardada.devoclucionPK.documento + '-' + guardada.devoclucionPK.secuencia;
        this.devolucion = guardada;
        var factura = guardada.facturasventa;
        var electronica = /^E[0-9]{12}$/.test((guardada.ncf || '').trim()) && factura && factura.sucursal && factura.sucursal.facturacionEletronica === true
          && factura.caja && factura.caja.facturacionEletronica === true;
        if (electronica) await this.DevolucionEletronicaGet(guardada);
        else {  this.enviarImprimirDevolucion(guardada); }
      } catch (error) {
        var detalle = error && error.response && error.response.data;
        if (typeof detalle !== 'string') detalle = error && error.message || 'Error de comunicacion';
        this.alerta(this.guardadoDevolucionIncierto
          ? 'No se pudo confirmar el guardado. Consulte las devoluciones antes de repetir. ' + detalle
          : 'Devolucion guardada; no repita el registro. ' + detalle, 'error');
      } finally {
        this.guardandoDevolucion = false;
        this.ejecucion = true;
        this.loading(false);
      }
    },

async DevolucionEletronicaGet(FACT) {
      var devolucion = JSON.parse(JSON.stringify(FACT));
      var headers = Object.assign({}, this.$store.getters.GetheadersAxios);
      var control = { limite: Date.now() + 10000, cancelado: false, envioIniciado: false, headers };
      var temporizador;
      var procesamiento = Promise.resolve().then(() => this.$refs.RefPvDgiiFacturacionEletronica.procesarTokenXML_ECF_DEV(devolucion, 3, control));
      try {
        var resultado = await Promise.race([procesamiento, new Promise((resolve, reject) => {
          temporizador = setTimeout(() => {
            if (!control.envioIniciado) control.cancelado = true;
            reject(new Error('Tiempo de espera de DGII agotado'));
          }, 10000);
        })]);
        var track = resultado && resultado.objtrackId;
        if (!track || typeof track !== 'object' || Array.isArray(track) || !track.estado) throw new Error('Respuesta fiscal incompleta');
        for (var campo of ['encf','ncfElectronico']) {
          if (track[campo] && String(track[campo]).trim() !== devolucion.ncf.trim()) throw new Error('La respuesta fiscal pertenece a otro NCF');
        }
        if (JSON.stringify(headers) !== JSON.stringify(this.$store.getters.GetheadersAxios)) return;
        var estado = String(track.estado).trim().replace(/_/g, ' ').toLowerCase();
        if (!['aceptado','aceptado condicional','rechazado'].includes(estado)) {
          this.alerta('Devolucion ' + devolucion.ncf.trim() + ' guardada y pendiente en el coordinador. No repita el envio.', 'error');
          return;
        }
        if (estado === 'rechazado') {
          var mensajes = Array.isArray(track.mensajes) ? track.mensajes : [];
          this.alerta('NCF ' + devolucion.ncf.trim() + ' rechazado por DGII. ' + mensajes.map(m => 'COD:' + m.codigo + ': ' + m.valor).join('; '), 'error');
          if (track.origen !== 'FARMACIA') await this.actualizarDEV_ELETRONICA(devolucion, resultado, headers);
          return;
        }
        await this.actualizarDEV_ELETRONICA(devolucion, resultado, headers);
      } catch (error) {
        this.alerta(control.envioIniciado
          ? 'Devolucion guardada. Envio iniciado, pendiente de confirmacion; la API conservara la respuesta. No repita el envio.'
          : control.ecfRegistrado || error.ecfRegistrado
            ? 'Devolucion guardada y pendiente en el coordinador. No genere otra devolucion ni repita el envio.'
            : 'Devolucion guardada. No se pudo confirmar su registro electronico; revise el comprobante antes de reintentar. ' + error, 'error');
      } finally {
        clearTimeout(temporizador);
        this.loading(false);
      }
    },

async actualizarDEV_ELETRONICA(FACT, objCompTrackId, headers) {
      var track = objCompTrackId.objtrackId;
      var datos = { documento: FACT.devoclucionPK.documento, secuencia: FACT.devoclucionPK.secuencia,
        fechafirmadgii: objCompTrackId.fechafirmadgii, qrdgii: objCompTrackId.qrdgii,
        signatureValue: objCompTrackId.signatureValue, trackId: JSON.stringify(track) };
      var guardada = Object.assign({}, FACT, { trackId: datos.trackId, qrdgii: datos.qrdgii,
        signatureValue: datos.signatureValue, fechafirmadgii: datos.fechafirmadgii });
      // El coordinador ya sincronizo devolucion y NC vinculada en la misma transaccion.
      if (track.origen !== 'FARMACIA') {
        var respuesta = await this.$axios.post(this.$hostname + this.$hName + '/devolucion/actualizarDevolicionEletronica', datos,
          { headers: headers || this.$store.getters.GetheadersAxios, timeout: 10000 });
        guardada = respuesta.data;
        if (FACT.notacreditoclientes) await this.actualizarNOTA_CreditoCxC_ELETRONICA(FACT.notacreditoclientes, objCompTrackId, headers);
      }
      this.devolucion = guardada;
      if (['aceptado','aceptado condicional'].includes(String(track.estado).trim().toLowerCase())) {
        
        this.enviarImprimirDevolucion(guardada);
      }
    },

async actualizarNOTA_CreditoCxC_ELETRONICA(FACT, objCompTrackId, headers) {
      if (!FACT.ncf || FACT.ncf.trim() !== this.devolucion.ncf.trim()) throw new Error('La nota vinculada pertenece a otro NCF');
      await this.$axios.post(this.$hostname + this.$hName + '/notacreditocliente/actualizarFactEletronica', {
        documento: FACT.notacreditoclientesPK.documento, secuencia: FACT.notacreditoclientesPK.secuencia,
        fechafirmadgii: objCompTrackId.fechafirmadgii, qrdgii: objCompTrackId.qrdgii,
        signatureValue: objCompTrackId.signatureValue, trackId: JSON.stringify(objCompTrackId.objtrackId)
      }, { headers: headers || this.$store.getters.GetheadersAxios, timeout: 10000 });
    },
 

enviarImprimirDevolucion(DEV){

  DEV.caja=0
  var Config = this.$store.getters.GetConfiguracionGeneral
/**/var _this = this;
setTimeout(function () { 
  _this.alerta("Devolucion salvada correctamente !!!", "bien");
            if (localStorage.printerSelect != null) { }
            var selectImpre=(localStorage.printerSelect!=undefined?JSON.parse(localStorage.printerSelect):null)
            var impresora=null
            if(selectImpre!=null && selectImpre.hasOwnProperty('nombre')){
              impresora=JSON.parse(localStorage.printerSelect).nombre
              }
              var msg = {
                accion: "print",
                formato: DEV.facturasventa.caja.formatoimpresioncontado.trim(),
                impresora: impresora,
                data: Config,
                devolucion: DEV,
                caja: DEV.facturasventa.caja,
                cajero: _this.$store.getters.GetOtrasConfigPv.cajero,
              };
              _this.imprimir(msg, "devolucion");
            _this.newwnuevo();
}, 100);

},


 // Envío de una solicitud POST al servidor con los datos a imprimir.
    imprimir(datos, operacion) {

      datos.operacion = operacion;
      datos.schema = this.$store.getters.GetheadersAxios["X-TENANT-ID"]
      if (datos.formato.trim() === "rolloBlue") {
if(datos.operacion.trim()==="factura"){
var FACT=datos.fac.hasOwnProperty('factura')? datos.fac.factura.factura:datos.fac
var _this = this;
setTimeout(function () {
  _this.$refs.RefPvImprecionViewer.GetPrintFacturaVenta(FACT)
  // _this.$refs.RefPvImprecionViewer.GetPrintFacturaVenta(datos.fac.factura.factura)
}, 800);
       
}

      }else{
        if(datos.impresora==null){
          this.alerta(" seleccione la impresora","error")
          return
        }

        if (datos.formato === "fiscale") {
        this.$axios.get("http://localhost:15999/impresora/imprimir/validad").then(res => {
          if (res.data.LastError ===0) {
          this.$axios
          .post("http://localhost:15999/impresora/imprimir", datos)
          .then((res) => {
           // this.newwnuevo();;
          })
          .catch((error) => { 
            this.ejecucion=true 
            console.error(error)
          });
          }else{
            //this.cancelarUltimoDocumento();
            //this.alerta("La impresora esta desconectada o esta apagada!!!","error")
            return;
          }
        })
        .catch((error) => { 
            this.ejecucion=true 
            console.error(error)
          });
      }else{
        this.$axios
          .post("http://localhost:15999/impresora/imprimir", datos)
          .then((res) => {
           // this.newwnuevo();
          })
          .catch((error) => {
            console.error(error)
            this.ejecucion=true 
          });
      }

      }

      
    },

  
// Limpiando el filtro y recargando la mesa.
    Limpiarfiltro() {


      var Pg = {
        itemsLength: this.TbPaginatorBarraDin.itemsLength,
        itemsPerPage: this.TbPaginatorBarraDin.itemsPerPage,
        page: 1,
        pageCount: 1,
        pageStart: 0,
        pageStop: this.TbPaginatorBarraDin.itemsPerPage,
      }

      this.Modallfiltro = {
        codDevo: null,
        cliente: null,
        documento: null,
        Desde: null,
        Hasta: null,
      }

      this.ListItemsBarraDin = []
      this.TbTotalItemBarraDin = 0

      this.TbPaginatorBarraDin = JSON.parse(JSON.stringify(Pg))
      this.CargarListTb()
      this.dialogFiltros = false

    },

 BuscarFiltros() {
      var Pg = {
        itemsLength: this.TbPaginatorBarraDin.itemsLength,
        itemsPerPage: this.TbPaginatorBarraDin.itemsPerPage,
        page: 1,
        pageCount: 1,
        pageStart: 0,
        pageStop: this.TbPaginatorBarraDin.itemsPerPage,
      }

      if (this.Modallfiltro.codDevo != null && this.Modallfiltro.codDevo.toString().length == 0) { this.Modallfiltro.codDevo = null }
      this.TbPaginatorBarraDin = JSON.parse(JSON.stringify(Pg))
      this.CargarListTb()
      this.dialogFiltros = false
    },
 
   // Establecer el valor predeterminado de itemsPerPage en 15.
    cargarPaginacionAll(e) {
      if (e.itemsPerPage == -1) { e.itemsPerPage = 15 }
      this.CargarPaginacionBarraDin(e, this.Modallfiltro.cliente)
    },

   // Un método que se llama cuando el usuario hace clic en los botones de paginación.
    CargarPaginacionBarraDin(e, s) {

      this.Modallfiltro.codDevo = JSON.parse(JSON.stringify(s))

      if (e.itemsPerPage == -1) { e.itemsPerPage = 15 }
      //var pg =
      this.TbPaginatorBarraDin = JSON.parse(JSON.stringify(e))
      this.CargarListTb()

    },

    // Llamar a un método que está en el backend, que se encarga de devolver los datos al frontend.
    CargarListTb() {

      var clie = null
      var codDevo =0
      var codDoc=0
      if (this.Modallfiltro.cliente != null) { clie = this.Modallfiltro.cliente.nombre }
      if (this.Modallfiltro.documento != null) { codDoc = this.Modallfiltro.documento.codigo }
      if (this.Modallfiltro.codDevo != null && this.Modallfiltro.codDevo.trim().length >0) { codDevo = this.Modallfiltro.codDevo }
  
      var obj = codDevo+ "/" +this.Modallfiltro.Desde + "/" + this.Modallfiltro.Hasta +"/"+clie+"/"   
      +this.TbPaginatorBarraDin.itemsPerPage + "/" + this.TbPaginatorBarraDin.pageStart

      this.$axios.get(this.$hostname + this.$hName + '/reimpresion/devolucion/' + obj, { headers: this.$store.getters.GetheadersAxios })
        .then(res => { 
          this.ListItemsBarraDin = res.data.listas, this.TbTotalItemBarraDin = res.data.cantidad

        })
    },

 // Realizar una solicitud GET al servidor y devolver los datos al componente Vue.
    cargarCliente() {
      this.$axios.get(this.$hostname + this.$hName + '/clientes/findtodo/a/3/25/0', { headers: this.$store.getters.GetheadersAxios })
        .then(res => (this.RCliente = res.data))
    },


 // Llamar a una API y devolver una lista de clientes.
    CbFilcliente(e) {
      if (e.target.value.length >= 2) {
        this.$axios
          .get(
            this.$hostname +
            this.$hName +
            "/clientes/findtodo/" +
            (e.target.value === "" ? "A" : e.target.value) +
            "/3/25/0",
            { headers: this.$store.getters.GetheadersAxios }
          )
          .then(res => (this.RCliente = res.data));
      }

    },

     // Comprobando si el valor de la selección es nulo o indefinido.
    SelctCbClienteFiltro() {

var _this = this;
      setTimeout(function () {
        if (_this.Modallfiltro.cliente == null) {
          _this.Modallfiltro.cliente = "";
        }

        if (!_this.Modallfiltro.cliente.hasOwnProperty('codigo')) {
          _this.Modallfiltro.cliente = "";
          _this.Modallfiltro.cliente = null;
          return;
        }

      }, 300);

    },

    // Comprobando si el valor de la selección es nulo o indefinido.

    SelctCbDocumentoFiltro() {


      var _this = this;
      setTimeout(function () {
        if (_this.Modallfiltro.documento == null) {
          _this.Modallfiltro.documento = "";
        }

        if (!_this.Modallfiltro.documento.hasOwnProperty('codigo')) {
          _this.Modallfiltro.documento = "";
          _this.Modallfiltro.documento = null;
          return;
        }
      }, 300);

    },



 loaderTablaCargar(){
              this.loaderTabla=true
        var _this=this;
        setTimeout(function(){ _this.loaderTabla=false }, 999);
            },

   loading(e) {
      EventBus.$emit("loading", e);
    },



    alerta(e, l) {
      if (l == "bien") {
        (this.aalert.estado = true),
          (this.aalert.color = "success"),
          (this.aalert.nombre = e);

        this.newwnuevo();
      }

      if (l == "error") {
        (this.aalert.estado = true),
          (this.aalert.color = "error"),
          (this.aalert.nombre = e);

        this.ejecucion = true;
      }
    },




    actualiza_tb_ver() {
      this.acti_tb_data = !this.acti_tb_data;
      this.filtro();
    },

    async filtro() {
      await this.$axios
        .post(this.$hostname + this.$hName + "/services/tipocliente/findalltipoclientes", {
          usuario:JSON.parse(JSON.stringify(this.$user)) 
        })
        .then(res => {
          this.list = res.data;
        });
    },

  },


computed:{

    ActDescBtn(){

this.windowSize=JSON.parse(JSON.stringify(this.$store.getters.GetwindowSize)) 


if( this.devClientes.cliente!=null && this.devClientes.cliente.hasOwnProperty('codigo')){
 // this.infCliente=JSON.parse(JSON.stringify(this.HistorialCliente.cliente))

 if(this.devClientes.cliente.balancecliente!=null){
  this.infCliente.balance=JSON.parse(JSON.stringify(this.devClientes.cliente.balancecliente.balance)) 
    }else{this.infCliente.balance=0}

  if(this.devClientes.cliente.telefonosClientesList.length>0){
    this.infCliente.telefono= "Tel. "+JSON.parse(JSON.stringify(this.devClientes.cliente.telefonosClientesList[0].telefonosClientesPK.telefono))
  }else{ this.infCliente.telefono=''}

}else{

this.infCliente={
balance:0,
telefono:''
}
}

if(this.devClientes.soloImprimir==true){
  this.EstadoBtn.imprimir=true
}else{
  this.EstadoBtn.imprimir=false
}

if(this.devClientes.soloImprimir==false && this.selectedlistFactVent.length>0){
this.EstadoBtn.guardar=true
}else{
this.EstadoBtn.guardar=false
}

    }
  }


};
</script>

<style></style>
